module.exports = __webpack_public_path__ + "media/images/error-bf124b8d7d4753e943072026be2807c6.svg";